import {registerInitializer} from "../shared/utils";

export const initializeFilter = () => {
  $('#filter .title').click(function() {
    $('#filter .filter-options').toggle()
  });
};

registerInitializer(initializeFilter);
